var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"badge-preview",class:{ frame: _vm.includeFrame }},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":100,"color":"var(--personify-violet)","indeterminate":""}}):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.parsedBadge)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }